export default __webpack_public_path__ + "static/media/icon-eta-clock.8c45f78c.svg";